import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["clipPath",{"id":"curve-ve_svg__a","stroke-linejoin":"round","key":"svg-clipPath"}],["g",{"stroke":"#333","key":"svg-g"}]]);